import { jsxs, jsx } from 'react/jsx-runtime';
import { useId } from 'react';
import classNames from 'classnames';

var checkbox = "Checkbox-module_checkbox__afhtq";
var label = "Checkbox-module_label__867cL";
var inline = "Checkbox-module_inline__YGfkm";
var hiddenLabel = "Checkbox-module_hiddenLabel__-h7G1";
var checkboxInput = "Checkbox-module_checkboxInput__EnBZb";

const Checkbox = ({ id: givenId, hiddenLabel: hiddenLabel$1 = false, inline: inline$1 = false, children, className, labelClassName, ...otherProps }) => {
    const generatedId = useId();
    const id = givenId || generatedId;
    if (hiddenLabel$1 && !otherProps["aria-label"]) {
        throw new Error(`Missing aria-label in component#${id} with hidden label`);
    }
    return (jsxs("div", { className: classNames(checkbox, inline$1 && inline, className), children: [jsx("input", { className: checkboxInput, id: id, type: "checkbox", ...otherProps }), jsx("label", { className: classNames(label, hiddenLabel$1 && hiddenLabel, labelClassName), htmlFor: id, children: !hiddenLabel$1 && children })] }));
};

export { Checkbox };
